import React, { useState } from 'react';
import proptypes from 'prop-types';
const { arrayOf, func, string, bool, shape, objectOf } = proptypes;
import { LoadingButton } from '@one-thd/sui-atomic-components';
import { usePartsAndServices } from '../PartsAndServicesProvider';
import { partsAndServicesDataModel } from '../partsAndServicesDataModel';
import { ctaAnalytics } from '../../utils';

const CustomButton = ({
  disabled,
  text,
  onClick,
  variant,
  href
}) => {
  const [loading, setLoading] = useState(false);

  return (
    <LoadingButton
      data-automation-id="save"
      disabled={disabled}
      fullWidth
      loading={loading}
      onClick={(event) => {
        if (href) event.preventDefault();
        setLoading(true);
        onClick();
      }}
      variant={variant}
      href={href}
    >
      {text}
    </LoadingButton>
  );
};

CustomButton.defaultProps = {
  href: ''
};

CustomButton.propTypes = {
  disabled: bool.isRequired,
  text: string.isRequired,
  variant: string.isRequired,
  href: string,
  onClick: func.isRequired
};

CustomButton.displayName = 'CustomButton';

export const Buttons = ({ ctaButtons, ctaOptions, isProtection }) => {

  const {
    initiateCartPost,
    showLoadingSkeleton,
    currentPage,
    newItemsArray,
    newAddOnsArrays,
    newProductsArray,
    isPSPPServiceDown,
    currentExperience,
    isEnableCompatibleAccessoriesPAS,
    typeOfSelection,
    protectionSelections,
    installationSelections,
    haulAwaySelections
  } = usePartsAndServices();

  let buttons = ctaButtons;

  if (isPSPPServiceDown) {
    buttons = [];
    const cartBtnOption = currentExperience !== 'my-cart'
      ? ctaOptions?.continueToCart
      : ctaOptions?.returnToCartNoUpdate;

    buttons.push(cartBtnOption);

    if (isProtection && currentExperience !== 'my-cart') {
      buttons.push(ctaOptions?.keepShopping);
    }
  }

  const ctaAction = ({
    onSubmit = () => { },
    onSubmitClick = () => { },
    shouldPostSelectionsToCart = () => { },
  }) => {
    onSubmitClick({
      hdppSelection: protectionSelections,
      instalSelections: installationSelections,
      haulAndMoveSelections: haulAwaySelections,
      currentPage,
    });
    if (onSubmit && shouldPostSelectionsToCart) {
      initiateCartPost(onSubmit);
    } else if (onSubmit) {
      onSubmit();
      ctaAnalytics({
        newItemsArray,
        newAddOnsArrays,
        newProductsArray,
        currentPage,
        isEnableCompatibleAccessoriesPAS,
        typeOfSelection
      });
    }
  };

  return (
    <div data-testid="cta-section-page" className="sui-flex sui-flex-col sui-mt-3">
      {buttons.map(({
        buttonText,
        buttonVariant,
        onSubmitClick,
        onSubmit,
        shouldPostSelectionsToCart,
        href,
      }) => (
        <div key={buttonText} className="sui-pb-4">
          <CustomButton
            disabled={showLoadingSkeleton}
            text={buttonText}
            key={buttonText}
            href={href}
            onClick={() => ctaAction({ onSubmit, onSubmitClick, shouldPostSelectionsToCart })}
            variant={buttonVariant}
          />
        </div>
      )
      )}
    </div>
  );
};

Buttons.propTypes = {
  ctaButtons: arrayOf(shape({
    buttonText: string,
    buttonVariant: string,
    onSubmit: func,
    shouldPostSelectionsToCart: bool,
    href: string
  })).isRequired,
  ctaOptions: objectOf(shape({})),
  isProtection: bool,
};

Buttons.defaultProps = {
  isProtection: false,
  ctaOptions: {},
};

Buttons.dataModel = partsAndServicesDataModel;

Buttons.displayName = 'Buttons';
